import { useQuery } from '@tanstack/react-query';
import { buscarNumerosParaLigar, type ListaDeNumeros } from '@/lib/numerosParaLigarApi';

/** Todos os celulares do lead, na ordem do Auto Dialer. */
export function useNumerosParaLigar(leadId: string | null | undefined, ativo = true) {
  return useQuery({
    queryKey: ['numeros-para-ligar', leadId],
    enabled: !!leadId && ativo,
    staleTime: 5 * 60_000,
    queryFn: (): Promise<ListaDeNumeros> => buscarNumerosParaLigar(leadId as string),
  });
}
